import SvgIcon, { SvgIconProps } from 'LuxKit/SvgIcon'

function LineExclamationIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M12 14a1.0001 1.0001 0 0 0 1-1V7a1.0002 1.0002 0 0 0-1.7071-.7071A1.0002 1.0002 0 0 0 11 7v6a1.0001 1.0001 0 0 0 1 1Zm0 4a1.25 1.25 0 1 0 0-2.4999A1.25 1.25 0 0 0 12 18Z"/>
  </SvgIcon>
}

export default LineExclamationIcon
